import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { CoordinatesExact } from '../../models/Coordinates';
import { hexToRgba } from '../../../common/formatters/colorFormatter';

const Jurisdiction = ({ index, coordinatesArray, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: visible ? [coordinatesArray.map(({ longitude, latitude }) => [longitude, latitude])] : [],
      },
    }),
    [visible, coordinatesArray]
  );

  const color = theme.palette.map.jurisdiction[index % theme.palette.map.jurisdiction.length];

  return (
    <GeoJSONLayer
      id={`jurisdiction${index}`}
      data={sourceData}
      fillPaint={{
        'fill-color': hexToRgba(color, 0.1),
        'fill-outline-color': color,
      }}
    />
  );
};

Jurisdiction.propTypes = {
  coordinatesArray: PropTypes.arrayOf(CoordinatesExact),
  index: PropTypes.number,
  visible: PropTypes.bool,
};

Jurisdiction.defaultProps = {
  coordinatesArray: [],
  index: 0,
  visible: true,
};

export default React.memo(Jurisdiction);
